import {Component, OnInit, ViewChild} from '@angular/core';
import {ImportadorChinnaService} from "../../services/importador-chinna.service";
import {PainelImportacaoProdutosComponent} from "../painel-importacao-produtos/painel-importacao-produtos.component";
import {NgForm} from "@angular/forms";
import {ModalKendo} from "../../lib/ModalKendo";

@Component({
  selector: 'app-tela-sincronizar-china',
  templateUrl: './tela-sincronizar-china.component.html',
  styleUrls: ['./tela-sincronizar-china.component.scss']
})
export class TelaSincronizarChinaComponent extends ModalKendo implements OnInit {
  @ViewChild('frm', {static: false}) frm: NgForm;
  @ViewChild('painelImportacao', {static: false}) painelImportacao: PainelImportacaoProdutosComponent;
  mensagemSucesso: any;
  mensagemErro: any;
  carregandoProdutos: boolean;
  tudoSincronizado: boolean;
  buscarProdutos: boolean;
  buscouProdutos: boolean;
  opcoes: any = {};
  empresa: any = {};
  forcarChinaInBox = false;
  lojasChina: any[] = [];
  lojasChinaFiltradas: any[] = [];
  carregandoLojasChina = false;
  constructor(  private importadorChinnaService: ImportadorChinnaService) {
    super()
  }

  ngOnInit(): void {
    this.buscarProdutos = true
  }

  ehSiteChina(){
    return this.forcarChinaInBox ||
      (this.empresa.integracaoDelivery && this.empresa.integracaoDelivery.unidadeChina);
  }
  ehSiteGendai(){
    return !this.forcarChinaInBox &&
      this.empresa.integracaoDelivery && this.empresa.integracaoDelivery.unidadeGendai;
  }

  async carregueLojasChinaInBox() {
    this.carregandoLojasChina = true;
    this.fecheMensagemErro();
    try {
      this.lojasChina = await this.importadorChinnaService.listeLojasChinaInBox() || [];
      this.lojasChinaFiltradas = [...this.lojasChina];
      const maisProxima = this.lojasChina.find((loja: any) => loja.distancia === 0) || this.lojasChina[0];
      if(maisProxima) this.opcoes.lojaChinaId = maisProxima.id;
    } catch (erro) {
      this.mensagemErro = erro;
    } finally {
      this.carregandoLojasChina = false;
    }
  }

  filtreLojasChina(texto: string) {
    const termo = this.normalizeTexto(texto);
    this.lojasChinaFiltradas = !termo ? [...this.lojasChina] : this.lojasChina.filter((loja: any) =>
      this.normalizeTexto(loja.descricao).includes(termo));
  }

  obtenhaLojaChinaSelecionada() {
    return this.lojasChina.find((loja: any) => String(loja.id) === String(this.opcoes.lojaChinaId));
  }

  private normalizeTexto(valor: any): string {
    return String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  async carregueProdutosNovos(){
    this.fecheMensagemErro();
    const lojaChina = this.forcarChinaInBox ? this.obtenhaLojaChinaSelecionada() : null;
    if(this.forcarChinaInBox && !lojaChina) {
      this.mensagemErro = 'Selecione uma unidade China In Box.';
      return;
    }
    this.carregandoProdutos = true;

    let resposta: any;

    resposta = await this.importadorChinnaService.listeNovosProdutos(this.opcoes.sincronizarPrecos,
                                                        this.opcoes.sincronizarImagens,
                                                        this.forcarChinaInBox,
                                                        lojaChina).catch( erro => {
      this.mensagemErro = erro
    })

    this.carregandoProdutos = false;
    this.buscouProdutos = true;

    if(resposta){

      if(resposta.categorias.length){
        this.buscarProdutos = false;
      } else {
        this.tudoSincronizado =  true;
      }

      this.painelImportacao.setProdutosSincronizar(resposta.novosProdutos,
        resposta.produtosAtualizar, resposta.produtosRemovidos, resposta.categorias)
    }

  }

  submitFormBusca() {
    this.frm.ngSubmit.emit()
  }

  fecheMensagemErro() {
    delete  this.mensagemErro;
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }

  feche() {
    this.fecheModal(this.painelImportacao.importou)
  }

}
